/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBaseLeadsResponse } from '../../models/get-base-leads-response';

export interface ListBaseLeads$Params {
  page?: number;
  size?: number;
  search?: string;
}

export function listBaseLeads(http: HttpClient, rootUrl: string, params?: ListBaseLeads$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBaseLeadsResponse>> {
  const rb = new RequestBuilder(rootUrl, listBaseLeads.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBaseLeadsResponse>;
    })
  );
}

listBaseLeads.PATH = '/api/scheduler/bases/base-leads';
